import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * Attachment document interface
 */
export interface AttachmentDocument extends BaseDocument {
  entityType: string
  entityId: string
  fileName: string
  fileType: string
  fileSizeBytes: number
  storageKey: string
  fileUrl: string | null
  description: string | null
  uploadStatus: number // 0=PendingUpload, 1=Uploaded, 2=Failed
  createdByName: string | null
  createdByEmail: string | null
}

/**
 * Attachment-specific hooks
 */
const hooks = createEntityHooks<AttachmentDocument>('attachments')

export const useAttachments = (filter?: Partial<AttachmentDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { attachments: data, isLoading, db }
}

export const useAttachment = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { attachment: data, isLoading }
}

export const useAttachmentMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createAttachment: create,
    updateAttachment: update,
    deleteAttachment: deleteEntity,
  }
}
